var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_user-agent.js
// module id = 214
// module chunks = 0